import { buildVenuePath } from '../utils/venueRouting';
// src/pages/Home.jsx
import React, { useState, useEffect, useContext } from 'react';
import AppContext from '../contexts/AppContext';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { useNavigate } from 'react-router-dom';
import AdvTabs from '../components/AdvTabs';
import LilydaleOasisHome from './LilydaleOasisHome';
import { contentLog } from '../utils/Accesslog.js';
import { getLuminance } from '../utils/ColorLuminance.js';

const Home = () => {
  const { hotelInfo, contentInfo, venueId, theme } = useContext(AppContext);
  const [quickLinks, setQuickLinks] = useState([])
  const navigate = useNavigate();

  useEffect(() => {
    if (
      hotelInfo &&
      hotelInfo.landing &&
      hotelInfo.landing.quickLinkIds &&
      hotelInfo.landing.quickLinkIds.length &&
      contentInfo
    ) {
      const quickLinksTemp = [];

      // 使用一个 Map 结构来快速查找 contentInfo 树中对应的 ID
      const mapContentById = (contentInfo, map = new Map()) => {
        map.set(contentInfo.id, contentInfo);
        if (!contentInfo.isLeaf && contentInfo.attributes) {
          contentInfo.attributes.forEach((attr) => {
            mapContentById(attr, map);
          });
        }
        return map;
      };

      // 构建 contentInfo 树的 Map
      const contentMap = mapContentById(contentInfo);

      // 根据 quickLinkIds 顺序查找对应的内容
      hotelInfo.landing.quickLinkIds.forEach((id) => {
        if (contentMap.has(id)) {
          const matchedContent = contentMap.get(id);
          quickLinksTemp.push({
            id: matchedContent.id,
            isLeaf: matchedContent.isLeaf,
            name: matchedContent.name,
            image: matchedContent.bannerImage,
          });
        }
      });

      setQuickLinks(quickLinksTemp);
    }
  }, [contentInfo, hotelInfo]);

  const handleLinkClick = (data) => {
    contentLog(venueId, data.id);
    if (data.isLeaf) {
      navigate(buildVenuePath(`/service/detail/${data.id}`, venueId));
    }
    else
      navigate(buildVenuePath(`/service/list/${data.id}`, venueId))
  }

  if (!hotelInfo) { return <div>Loading...</div>; }

  if (venueId === 've_elysianshor_qb') {
    return (
      <LilydaleOasisHome
        hotelInfo={hotelInfo}
        quickLinks={quickLinks}
        onQuickLinkClick={handleLinkClick}
        theme={theme}
      />
    );
  }

  const themeColor = theme?.primaryColor || theme?.color || 'rgb(0,0,0)';
  const textColor = theme?.secondaryColor || 'rgb(255,255,255)';
  const designedColor = getLuminance(themeColor) > 0.7 ? textColor : themeColor;

  const homeHeader = (theme?.color || theme?.secondaryColor) ? designedColor : (theme?.homeHeader || 'rgb(0,0,0)');
  const homeContent = (theme?.color || theme?.secondaryColor) ? designedColor : (theme?.homeContent || 'rgb(75,85,99)');
  const homeQuickLinksEntries = (theme?.color || theme?.secondaryColor) ? designedColor : (theme?.homeQuickLinksEntries || 'rgb(0,0,0)');
  const homeBackground = (theme?.color || theme?.secondaryColor) ? "rgb(255,255,255)" : (theme?.homeBackground || 'rgb(255,255,255)');

  return (
    <div style={{ backgroundColor: homeBackground }}>
      <div className='mb-4'>
        {hotelInfo && hotelInfo.landing && hotelInfo.landing.homeImages.length > 0 && (
          hotelInfo.landing.homeImages.length === 1 ?
            <img src={hotelInfo.landing.homeImages[0]} alt='homeImage' className='object-cover w-full h-36' /> :
            <Carousel
              showArrows={true}
              showThumbs={false}
              infiniteLoop={true}
              autoPlay={true}
              showIndicators={false}
              showStatus={false}
              className="w-full h-full"
            >
              {hotelInfo.landing.homeImages.map((slide, index) => (
                <div key={index} className="w-full h-full">
                  <img
                    src={slide}
                    alt={`Home ${index + 1}`}
                    className="object-cover w-full h-36"
                  />
                </div>
              ))}
            </Carousel>
        )}
        {hotelInfo && hotelInfo.landing && hotelInfo.landing.homeTitle.length > 0 &&
          <p className='text-xl text-center p-2 font-semibold' style={{ color: homeHeader }}>{hotelInfo.landing.homeTitle}</p>}
        {hotelInfo && hotelInfo.landing && hotelInfo.landing.homeDescription.length > 0 &&
          <p className='px-6 text-xs whitespace-pre-wrap' style={{ homeContent }}>{hotelInfo.landing.homeDescription}</p>}
      </div>
      <AdvTabs origin={'Home'} />
      {quickLinks.length > 0 && (
        <div className="text-center">
          <p className="text-xl font-semibold p-2" style={{ color: homeHeader }}>
            Quick Links
          </p>
          <div className="grid grid-cols-2 max-w-md mx-auto px-2">
            {quickLinks.map((data, index) => (
              <div key={index} className="flex flex-col items-center px-2 py-1"
                onClick={() => handleLinkClick(data)}>
                <div className="w-full aspect-w-1 aspect-h-1">
                  <img
                    src={data.image}
                    alt={`Quick Link ${index + 1}`}
                    className="object-cover rounded-lg w-full h-full"
                  />
                </div>
                <p className="mt-2 font-semibold" style={{ color: homeQuickLinksEntries }}>{data.name}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
